<template>
  <Modal
  :value="() => {}"
  :onClose="() => {}"
  :close="false"
  title="Pagamento com cartão"
  >
    <b-row class="form-group center">
      <b-col sm="12">
        <p>A transação foi enviada para o POS</p>
        <p><b>ZPOS > Pagamento</b><br>Aguardando o pagamento no POS...</p>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button type="white" @click="handleCancelTransaction()">Cancelar Transação</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';

export default {
  name: 'ModalZposTransaction',
  components: {
    Modal,
    Button,
  },
  props: {
    cancelTransaction: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleCancelTransaction() {
      return this.cancelTransaction();
    },
  },
};
</script>

<style>
  .center {
    text-align: center!important;
  }
</style>
